<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">好评返现<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="邀请时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="提交时间" @date="getSubmitTime($event)" @check="getSubmitCheck($event)" :isChecked="isSubmitChecked"/>
            </div>
            <div class="content-input-item">
              <label>邀请次数</label>
              <el-select v-model="inviteEvaluationNumMin" placeholder="Select" class="select-item">
                <el-option v-for="item in inviteEvaluationNumMinArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span style="margin: 0 8px">-</span>
              <el-select v-model="inviteEvaluationNumMax" placeholder="Select" class="select-item">
                <el-option v-for="item in inviteEvaluationNumMaxArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

            </div>
            <div class="content-input-item">
              <label>审核状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item" @change="stateChange">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <label style="margin-left: 24px" v-show="state == 2">打款状态</label>
              <el-select v-model="remitState" placeholder="Select" class="select-item" v-show="state == 2">
                <el-option v-for="item in remitStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <!--              <label>客户搜索</label>-->
              <SearchComponents width="7.2em" :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>
        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-space>
              <el-button type="primary" @click="batchUpdateState" v-loading="batchLoading" size="default">批量通过审核</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-badge is-dot :hidden="needAuditNum == 0">
                <el-button @click="buttonTypeChange(1, true)">审核中<span v-if="needAuditNum > 0">（{{needAuditNum}}）</span></el-button>
              </el-badge>
              <el-badge is-dot :hidden="needRemitNum == 0">
                <el-button @click="buttonTypeChange(2, true)">未打款<span v-if="needRemitNum > 0">（{{needRemitNum}}）</span></el-button>
              </el-badge>
            </el-space>
          </div>
          <div style="display: flex;align-items: center;">
            <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
          </div>

        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              @selection-change="selsChange"
              @header-click="selsAll"
              size="default"
              border
          >
            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
            <el-table-column property="createTime" label="邀请时间" v-if="checkColList.indexOf('邀请时间') > -1" />
            <el-table-column property="submitTime" label="提交时间" v-if="checkColList.indexOf('提交时间') > -1" />
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1" />

            <el-table-column property="" label="客户信息" v-if="checkColList.indexOf('客户信息') > -1" width="160">
              <template #default="scope">
                <UserInfo :userId="scope.row.userInfo.id" :row="scope.row.userInfo" showList="name,sex,phone,shopName,uid" @confirm="getPage"/>
              </template>
            </el-table-column>
            <el-table-column property="inviteEvaluationNum" label="邀请次数" v-if="checkColList.indexOf('邀请次数') > -1"/>
            <el-table-column property="numberNo" label="消费单号" v-if="checkColList.indexOf('消费单号') > -1"/>
            <el-table-column property="" label="评价详情" v-if="checkColList.indexOf('评价详情') > -1" width="110">
              <template #default="scope">
                <el-image class="item-img" fit="cover" :src="scope.row.smallEvaluationImg" @click.prevent="showImg(scope.row.evaluationImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </template>
            </el-table-column>
            <el-table-column property="" label="实付截图" v-if="checkColList.indexOf('实付截图') > -1" width="110">
              <template #default="scope">
                <el-image class="item-img" fit="cover" :src="scope.row.smallPayImg" @click.prevent="showImg(scope.row.payImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </template>
            </el-table-column>
            <el-table-column property="" label="收款码" v-if="checkColList.indexOf('收款码') > -1" width="110">
              <template #default="scope">
                <el-image class="item-img" fit="cover" :src="scope.row.smallPayeeImg" @click.prevent="showImg(scope.row.payeeImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </template>
            </el-table-column>

            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p>{{scope.row.state == 0?'待提交':scope.row.state == 1?'待审核':scope.row.state == 2?'审核通过':scope.row.state == 3?'审核不通过':scope.row.state == 4?'已过期':''}}</p>
                <p>{{scope.row.remitState == 0?'未打款':scope.row.remitState == 1?'已打款':''}}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button :disabled="scope.row.remitState == 1" v-if="scope.row.state > 0 && scope.row.state != 4" type="primary" size="small" @click="cashbackImgDialog(scope.$index, scope.row)">审核</el-button>
                  <el-button v-if="scope.row.state == 2" type="warning" size="small" @click="addPayImg(scope.row)">返现打款</el-button>
                </el-space>
              </template>
            </el-table-column>

            <el-table-column property="" label="打款截图" v-if="checkColList.indexOf('打款截图') > -1" width="110">
              <template #default="scope">
                <el-image class="item-img" fit="cover" :src="scope.row.remitImg" @click.prevent="showImg(scope.row.remitImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </template>
            </el-table-column>

            <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" class-name="cursor"></el-table-column>
          </el-table>
          <div>
            <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData,imgPostFormData } from "@/api/api";
import {
  getCashbackPageList,
  getCashbackStatStateNum,
  getSysListMenuTag, updateCashbackState
} from "@/api/url";
// import UserDialog from "./components/UserDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import UserRemark from "@/components/Remark/UserRemark";
import UserLogList from "@/components/UserLogList/UserLogList";
import UserInfo from "@/components/User/userInfo"
import ConsumeList from "@/views/user/components/ConsumeList";
import unLock from "@/layout/components/unLock";
import DatePickerRange from "@/components/DatePickerRange";
import RecheckDialog from "@/views/visit/components/RecheckDialog";
import userInfoDialog from "@/components/User/userInfoDialog";
import CashbackRemarkDialog from "@/views/cashback/components/CashbackRemarkDialog";
import payImgDialog from "@/views/cashback/components/payImgDialog";
import ImgViewer from "@/assets/js/imageViewer";
import CashbackDialog from "@/views/cashback/components/CashbackDialog";

export default {
  name: "CashbackIndex",
  components: { BtnGroup, SearchComponents, UserRemark, UserInfo, ConsumeList, UserLogList, unLock, DatePickerRange},
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      batchLoading: false,

      shopIdArray: [
        {name: '不限', id: 0}
      ],
      shopIdArr:[],
      shopId: 0,

      inviteEvaluationNumMinArray: [
        {label: '不限', value: 0},
        {label: '1', value: 1},
        {label: '2', value: 2},
        {label: '3', value: 3},
        {label: '4', value: 4},
        {label: '5', value: 5},
        {label: '6', value: 6},
        {label: '7', value: 7},
        {label: '8', value: 8},
        {label: '9', value: 9},
        {label: '10', value: 10},
        {label: '10次以上', value: 11},
      ],

      inviteEvaluationNumMaxArray: [
        {label: '不限', value: 0},
        {label: '1', value: 1},
        {label: '2', value: 2},
        {label: '3', value: 3},
        {label: '4', value: 4},
        {label: '5', value: 5},
        {label: '6', value: 6},
        {label: '7', value: 7},
        {label: '8', value: 8},
        {label: '9', value: 9},
        {label: '10', value: 10}
      ],

      inviteEvaluationNumMin: 0,
      inviteEvaluationNumMax: 0,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待提交', value: 0},
        {label: '待审核', value: 1},
        {label: '审核通过', value: 2},
        {label: '审核不通过', value: 3},
        {label: '已过期', value: 4},
      ],
      state: -1,

      remitStateArray: [
        {label: '不限', value: -1},
        {label: '未打款', value: 0},
        {label: '已打款', value: 1},
      ],
      remitState: -1,


      //邀请时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //提交时间
      submitStartTime: '',
      submitEndTime: '',
      isSubmitChecked: true,


      //刷新组
      colList: ['邀请时间', '提交时间', '所属门店', '客户信息', '邀请次数', '消费单号', '评价详情', '实付截图','收款码', '状态', '操作', '打款截图', '备注'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '主人ID', value : 3},
      ],
      searchType: 1,
      searchValue: '',
      limitState: false,

      upUserLoading: false,
      upPetLoading: false,

      buttonType: -1,

      idArray: [],



      needAuditNum: 0,
      needRemitNum: 0,

      operateState: JSON.parse(sessionStorage.getItem('operateState')),

    }
  },
  methods: {

    stateChange(val) {
      if(val != 2) {
        this.remitState = -1
      }
    },

    userInfoDialog(id) {
      Dialog.open({
        title: '',
        component: userInfoDialog,
        data: {
          userId: id,
          width: '640px',
        },
        confirm: () => {
        }
      })
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },


    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.isSubmitChecked = true;
      this.limitState = false;
      this.remitState = -1;
      this.inviteEvaluationNumMin = 0;
      this.inviteEvaluationNumMax = 0;
      this.state = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    buttonTypeChange(state,reset) {
      this.buttonType = state
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;

        let param = {};
        param['pageNum'] = this.currentPage;
        param['shopId'] = this.shopId;
        param['inviteEvaluationNumMin'] = 0;
        param['inviteEvaluationNumMax'] = 0;
        param['state'] = -1;
        param['remitState'] = -1;
        param['buttonType'] = this.buttonType;
        param['searchType'] = 1;
        param['searchValue'] = '';
        param['limitState'] = 0;
        param['startTime'] = '';
        param['endTime'] = '';
        param['submitStartTime'] = '';
        param['submitEndTime'] = '';

        this.sendPageReq(param);
      }
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSubmitTime(val) {
      this.submitStartTime = val[0];
      this.submitEndTime = val[1];
    },
    getSubmitCheck(val) {
      this.isSubmitChecked = val
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      if(this.buttonType == -1) {
        this.getPage();
      }else {
        this.buttonTypeChange(this.buttonType)
      }
    },


    getPage(reset) {
      this.buttonType = -1
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          // this.buttonType = -1
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['inviteEvaluationNumMin'] = this.inviteEvaluationNumMin;
      param['inviteEvaluationNumMax'] = this.inviteEvaluationNumMax;
      param['state'] = this.state;
      param['remitState'] = this.remitState;
      param['buttonType'] = this.buttonType;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['submitStartTime'] = this.submitStartTime;
      param['submitEndTime'] = this.submitEndTime;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getCashbackPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getStatNum()
          this.getMenuTag()
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },



    compare(a, b) {
      const bandA = a.shopId;
      const bandB = b.shopId;

      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },


    editRecheckDialog(idx, row) {
      let _title = '';
      let recheckForm = Object.assign({}, row);
      Dialog.open({
        title: _title,
        component: RecheckDialog,
        data: {
          recheckForm: recheckForm,
          width: '640px',
          operateState: this.operateState
        },
        close: (result) => {
          if(this.buttonType == -1) {
            this.getPage();
          }else {
            this.buttonTypeChange(this.buttonType)
          }
        }
      })
    },



    batchUpdateState() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请先选择记录',
          type: 'warning'
        });
        return false
      }
      this.$confirm('确定批量通过审核吗？').then(() => {
        this.batchLoading = true
        let param = {};
        param['idArr'] = this.idArray;
        param['state'] = 2;
        postFormData(updateCashbackState, param).then(data => {
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false;
        }).catch(()=> {
          this.batchLoading = false;
        })
      })
    },



    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if (column.label == '备注') {
        let remarkForm = Object.assign({}, row);
        Dialog.open({
          title: '备注',
          component: CashbackRemarkDialog,
          data: {
            remarkForm: remarkForm,
            width: '500px'
          },
          close: () => {
            this.getPage()
          }
        })
      }

    },

    cashbackImgDialog(idx, row) {
      let cashForm = Object.assign({}, row);
      Dialog.open({
        title: '图片审核',
        component: CashbackDialog,
        data: {
          cashForm: cashForm,
          width: '800px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    getStatNum() {
      getFormData(getCashbackStatStateNum, {shopId: this.shopId}).then(data => {
        this.needAuditNum = data.data.needAuditNum
        this.needRemitNum = data.data.needRemitNum
      })
    },

    // getMenuTag() {
    //   getFormData(getSysListMenuTag).then(data => {
    //     let list = data.data
    //     let tagList = []
    //     list.map(item => {
    //       if(item.tagNum > 0) {
    //         tagList.push(item.menuId)
    //       }
    //     })
    //     this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
    //   })
    // },

    getMenuTag() {
      getFormData(getSysListMenuTag).then(data => {
        let list = data.data
        let tagList = []
        list.map(item => {
          if(item.tagNum > 0) {
            tagList.push(item.menuId)
          }
        })
        let menuList = JSON.parse(localStorage.getItem('menuList'))
        menuList.map(item => {
          if(item.children && item.children.length > 0) {
            for(let i=0; i<item.children.length; i++) {
              if(tagList.indexOf(item.children[i].id) > -1) {
                tagList.push(item.id)
                break;
              }
            }
          }
        })
        this.$store.commit('UPDATE_MENU_TAG_LIST', tagList)
      })
    },

    addPayImg(row) {
      if((this.operateState & 512) != 512){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '该账号暂无打款操作权限',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '打款截图',
        component: payImgDialog,
        data: {
          cashbackForm: row,
          width: '400px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })

    // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.shopId = this.shopIdArray[0].id
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/

.item-img {
  width: 80px;
  height: 80px;
}
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 24px;
  cursor: pointer;
  margin: 0 auto
}
</style>
